import { ChatLiberacoesInstituicoes } from "./ChatLiberacoesInstituicoes";
import { ChatLiberacoesUsuarios } from "./ChatLiberacoesUsuarios";

export const ChatLiberacoes = () => (
  <div className="chat-liberacoes">
    <ChatLiberacoesInstituicoes />
    <ChatLiberacoesUsuarios />
  </div>
);
